export enum SchedulerStartBy {
    scheduler = 'scheduler',
    service = 'service',
}

export enum SchedulerStartByFriendly {
    scheduler = 'Pela agenda',
    service = 'Pelos serviços',
}

export enum SchedulerAppointmentType {
    all = 'all',
    balance = 'balance',
    recent = 'recent',
}

export enum SchedulerAppointmentTypeFriendly {
    all = 'Todos os serviços',
    balance = 'Apenas serviços em que o cliente possua saldo',
    recent = 'Serviços realizados recentemente pelo cliente',
}
